import { DialogOptions } from 'components/core/Dialog/common/Dialog';
import { FormattedMessage } from 'intl';
import { DialogTranslationKeys, CommonTranslationKeys } from 'intl/keys';
import { translationKeyToString } from 'intl/types/translationKey';

export function documentationFilteredFileResetDialog(): DialogOptions {
  return {
    catchOnCancel: false,
    title: (
      <FormattedMessage id={DialogTranslationKeys.confirmationFilteredFileResetTitle} />
    ),
    description: (
      <span>
        <FormattedMessage id={DialogTranslationKeys.confirmationFilteredFileResetDescription} />
      </span>
    ),
    customControllerLabels: [
      translationKeyToString(CommonTranslationKeys.cancel),
      translationKeyToString(CommonTranslationKeys.reset),
    ],
  };
}
